export const ru = {
    assign: 'Назначить',
    cancel: 'Отменить',
    'cpa-strategy-note':
        'Ставка будет применена только к фильтрам со стратегией «Оптимизация количества конверсий» и «Оптимизация количества кликов».',
    'cpc-strategy-note': 'Ставка будет применена только к фильтрам со стратегией «Оптимизация количества кликов».',
    'rate-label': 'Назначить ставку {rateType}'
};
